<template>
  <div
    v-if="ot"
    class="otDisplay"
  >
    <span v-if="label">{{ label }}: </span>{{ ot | otHours }} <span v-if="remark">({{remark}})</span>
  </div>
</template>

<script>
  export default {
    name: 'OtDisplay',
    props: ['label', 'ot', 'remark'],
    filters: {
      otHours (val) {
        if (!val && val !== 0) return '0h'
        const hrs = Math.floor(val)
        const mins = Math.round((val - hrs) * 60)
        return mins > 0 ? `${hrs}h${mins}m` : `${hrs}h`
      },
    },
  }
</script>

<style scoped>
.otDisplay {
  padding-left: 10px;
}
</style>
